<template>
  <div>
    <div class="animates-items mb16">
      <border-radius
        :borderTypeFlag.sync="borderTypeFlag"
        :borderRadius.sync="borderRadius"
        :borderTopLeftRadius.sync="borderTopLeftRadius"
        :borderTopRightRadius.sync="borderTopRightRadius"
        :borderBottomRightRadius.sync="borderBottomRightRadius"
        :borderBottomLeftRadius.sync="borderBottomLeftRadius"
      />
    </div>
    <div class="animates-items">
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDuration"
        title="持续"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDelay"
        title="延迟"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <div class="verticallyCenter">
        <div class="mr16">触发</div>
        <div class="content">
          <el-radio-group v-model="animateDataVal.animationIterationCount">
            <el-radio
              v-for="(option, index) in triggerstyles.list"
              :key="index"
              :label="option.value"
              :disabled="option.disabled"
              >{{ option.title }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { historyIgnoreWrap } from "utils/revork"
export default {
  name: "borderRadius-setting",
  components: {},
  props: {
    animateData: {
      type: Object
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      triggerstyles: {
        type: "触发次数",
        checked: "单次触发",
        list: [
          {
            value: 1,
            disabled: false,
            title: "单次触发"
          },
          {
            value: 2,
            disabled: false,
            title: "多次触发"
          }
        ]
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    animateDataVal: {
      get() {
        return this.animateData
      },
      set(newVal) {
        this.$emit("update:animateData", newVal)
      }
    },
    borderVariable: {
      get() {
        if (!this.animateDataVal.aborderRadius || JSON.stringify(this.animateDataVal.aborderRadius) === "{}") {
          let options = JSON.parse(JSON.stringify(this.options))
          this.animateDataVal.aborderRadius = {
            borderTypeFlag: options.borderTypeFlag,
            borderRadius: options.borderRadius &&  options.borderRadius.toString().indexOf("%")>-1?0:options.borderRadius,
            borderTopLeftRadius: options.borderTopLeftRadius.toString().indexOf("%")>-1?0:options.borderTopLeftRadius,
            borderTopRightRadius: options.borderTopRightRadius.toString().indexOf("%")>-1?0:options.borderTopRightRadius,
            borderBottomLeftRadius: options.borderBottomLeftRadius.toString().indexOf("%")>-1?0:options.borderBottomLeftRadius,
            borderBottomRightRadius: options.borderBottomRightRadius.toString().indexOf("%")>-1?0:options.borderBottomRightRadius
          }
        }
        return this.animateDataVal.aborderRadius
      }
    },
    borderTypeFlag: {
      get() {
        return this.borderVariable.borderTypeFlag
      },
      set(newVal) {
        this.$set(this.borderVariable, "borderTypeFlag", newVal)
      }
    },
    borderRadius: {
      get() {
        return this.borderVariable.borderRadius
      },
      set(newVal) {
        historyIgnoreWrap(() => {
          if (this.borderTypeFlag === 2) {
            this.borderTopLeftRadius = newVal
            this.borderTopRightRadius = newVal
            this.borderBottomLeftRadius = newVal
            this.borderBottomRightRadius = newVal
          }
          this.$set(this.borderVariable, "borderRadius", newVal)
        })()
        this.getBorderRadiusStyle()
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.borderVariable.borderTopLeftRadius
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.borderTopRightRadius = newVal
          this.borderBottomRightRadius = newVal
          this.borderBottomLeftRadius = newVal
        }
        this.$set(this.borderVariable, "borderTopLeftRadius", newVal)
        this.getBorderRadiusStyle()
      }
    },
    borderTopRightRadius: {
      get() {
        return this.borderVariable.borderTopRightRadius
      },
      set(newVal) {
        this.$set(this.borderVariable, "borderTopRightRadius", newVal)
        this.getBorderRadiusStyle()
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.borderVariable.borderBottomLeftRadius
      },
      set(newVal) {
        this.$set(this.borderVariable, "borderBottomLeftRadius", newVal)
        this.getBorderRadiusStyle()
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.borderVariable.borderBottomRightRadius
      },
      set(newVal) {
        this.$set(this.borderVariable, "borderBottomRightRadius", newVal)
        this.getBorderRadiusStyle()
      }
    }
  },
  methods: {
    getBorderRadiusStyle() {
      let curBorderRadius = this.borderVariable
      let triggerType = this.animateDataVal.triggerType
      let unit
      if(Array.isArray(this.options.borderRadius)){
        unit = 'px'
      }else{
        unit = this.options.borderRadius && this.options.borderRadius.toString().indexOf("%")>-1?'':'px'
      }
      this.animateDataVal.variable[
        `${triggerType}OrgBorderRadius`
      ] = `var_borderOrgRadius_borderTopLeftRadius,borderTopRightRadius,borderBottomRightRadius,borderBottomLeftRadius_${unit}`
      this.animateDataVal.variable[
        `${triggerType}BorderRadius`
      ] = `${curBorderRadius.borderTopLeftRadius}px ${curBorderRadius.borderTopRightRadius}px ${curBorderRadius.borderBottomRightRadius}px ${curBorderRadius.borderBottomLeftRadius}px`
    }
  }
}
</script>

<style lang="scss" scoped></style>
